import './style.css'
import { tns } from "@/node_modules/tiny-slider/src/tiny-slider";

export default class HomeArticlesSlider {
    static selector = '.ha-slider';

    constructor(block) {
        this.block = block;
        this.sliderWrapper = this.block.querySelector('.ha-slider__wrapper');
    }

    onComplete() {
        const slider = tns({
            container: '#ha-slider',
            controlsContainer: this.block.querySelector('.ha-slider__nav'),
            gutter: 20,
            loop: true,
            navPosition: 'bottom',
            responsive: {
                765: {
                    items: 1,
                    gutter: 30,
                },
                1025: {
                    gutter: 40,
                    autoplay: true,
                    autoplayButton: true,
                    items: 5,
                }
            }
        })
    }
}
